import PropTypes from 'prop-types';

const getPax = (index = 1) => ({
  id: index,
  name: '',
  surnames: ''
});

const getDumbPax = () => ({
  name: '',
  surnames: ''
});

const paxPropTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  surnames: PropTypes.string
};

const visualPropTypes = {
  name: PropTypes.string,
  surnames: PropTypes.string
};

export {
  getPax,
  getDumbPax,
  paxPropTypes,
  visualPropTypes
};
